import type { BarLineChartDataPoint } from 'components/common/charts/bar-line-chart/bar-line-chart'
import type { WeeklyGmvPoint } from 'core/api/home/weekly-gmv'
import { getYearAndWeek } from 'core/utils/date'
import i18n from 'core/utils/i18n'

export type WeeklyGmvChartDataPoint = WeeklyGmvPoint &
  BarLineChartDataPoint & {
    label: string
    isCurrentWeek: boolean
    realizedGmvLine: number | null
    forecastGmvLine: number | null
  }

const formatWeeklyGmvWeekLabel = (point: WeeklyGmvPoint) =>
  `${i18n.t('general.weekLetter')}${String(point.week).padStart(2, '0')}`

export const fromWeeklyGmvPoints = (
  weeklyGmvPoints: WeeklyGmvPoint[],
  today = new Date()
): WeeklyGmvChartDataPoint[] => {
  const [currentYear, currentWeek] = getYearAndWeek(today)
  const currentWeekIndex = weeklyGmvPoints.findIndex(point => point.year === currentYear && point.week === currentWeek)

  return weeklyGmvPoints.map((point, index) => {
    const isCurrentWeek = index === currentWeekIndex
    const currentWeekForecast = isCurrentWeek ? point.forecastGmv : null

    return {
      ...point,
      label: formatWeeklyGmvWeekLabel(point),
      isCurrentWeek,
      realizedGmvLine: point.realizedGmv ?? currentWeekForecast,
      forecastGmvLine: isCurrentWeek ? currentWeekForecast : point.forecastGmv
    }
  })
}

export const hasTrajectory = (weeklyGmvPoints: WeeklyGmvPoint[]) =>
  weeklyGmvPoints.some(point => point.trajectoryGmv != null)
